<template>
  <div class="adminWarning bg-danger" v-if="isAdmin">
    <h3>Sie sind als Administrator eingeloggt!</h3>
    <p>Wenn sie als Administrator eingeloggt sind können sie keine Chats aktiv bearbeiten und es steht Ihnen
      nur
      eine eingeschränkte Auswahl an Funktionen zur Verfügung!</p>
  </div>
</template>
<script>
export default {
  name: 'AdminWarning',
  props: ['isAdmin']
}
</script>
